import { Box, ColorOptions, LoaderNew, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import React, { useEffect, useState } from 'react'
import { EmType } from '../..'
import { BusinessHierarchyList } from '../../../../components/BusinessHierarchyList'
import { useLazyApiData, useStores } from '../../../../data/store'
import { EntityListDetails } from './EntityListDetails'

const EntityHierarchy = ({ selectedEntity, type }: any) => {
  const { getParentChilsEntList, fetchSearchEntity, paginationNumber } = useStores((root) => ({
    getParentChilsEntList: root.getParentChildEntityList,
    fetchSearchEntity: root.fetchSearchEntity,
    paginationNumber: root.pagination.number,
  }))
  const [showDetails, setShowDetails] = useState(false)
  const [searchApi, searchHandler] = useLazyApiData(fetchSearchEntity)
  const [businessHierarchyData, setBusinessHierarchyData] = useState(null)

  useEffect(() => {
    if (paginationNumber) {
      setBusinessHierarchyData(
        getParentChilsEntList(
          type === EmType.Search
            ? selectedEntity?.id
            : selectedEntity?.identificationNumber?.length > 0
            ? selectedEntity?.identificationNumber
            : selectedEntity?.parentEntityIdentificationNumber?.length > 0
            ? selectedEntity?.parentEntityIdentificationNumber
            : selectedEntity?.subGroupIdentificationNumber,
        ),
      )
    }
  }, [
    getParentChilsEntList,
    paginationNumber,
    selectedEntity?.id,
    selectedEntity?.identificationNumber,
    selectedEntity?.parentEntityIdentificationNumber,
    selectedEntity?.subGroupIdentificationNumber,
    type,
  ])

  useEffect(() => {
    if (type === EmType.applicationQueue) {
      const id =
        selectedEntity?.identificationNumber?.length > 0
          ? selectedEntity?.identificationNumber
          : selectedEntity?.parentEntityIdentificationNumber?.length > 0
          ? selectedEntity?.parentEntityIdentificationNumber
          : selectedEntity?.subGroupIdentificationNumber
      searchApi(id, 'Entity ID', 'businessHiearchy')
    }
  }, [
    searchApi,
    selectedEntity?.identificationNumber,
    selectedEntity?.parentEntityIdentificationNumber,
    selectedEntity?.subGroupIdentificationNumber,
    type,
  ])
  const closeModal = () => {
    setShowDetails(false)
  }

  const renderDetails = (): React.ReactElement => {
    return (
      <EntityListDetails
        onClose={closeModal}
        list={businessHierarchyData?.childList}
        entity={businessHierarchyData?.entityName}
        group={businessHierarchyData?.groupName}
        subGroup={businessHierarchyData?.subGroupName}
        entityLevel={businessHierarchyData?.level}
      />
    )
  }

  // console.log('getParentChilsEntList: ', JSON.parse(JSON.stringify(businessHierarchyData)))
  // const navigation = useNavigation()

  const onExportPress = () => {}

  const onViewEntities = (data: any) => {
    setShowDetails(true)
  }
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} backgroundColor={'WHITE'}>
      <ModalDialog children={renderDetails()} show={showDetails} type={'Right'} onDismiss={closeModal} />
      <ModBox>
        <Box direction="row" w={'100%'} justifyContent={'space-between'}>
          <Box direction="row" justifyContent={'space-between'} w={'100%'}>
            <Text title={'Business Hierarchy'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
            <ModBox show={false}>
              <ButtonNew
                borderWidth={1}
                borderColor={'#E0E0E0' as ColorOptions}
                borderRadius={4}
                titleColor={'BLACK_21'}
                height={30}
                color={'WHITE'}
                title={'Export'}
                icon={'DOWNLOAD'}
                iconPaddingRight={'6'}
                onPress={onExportPress}
                width={90}
              />
            </ModBox>
          </Box>
        </Box>
        <Spacer size={40} direction={'vertical'} />
        <ModBox show={type === EmType.applicationQueue && searchHandler?.state === 'pending'}>
          <LoaderNew type={'large'} color={'PRIMARY'} />
        </ModBox>
        <ModBox
          show={
            type === EmType.applicationQueue
              ? searchHandler?.state === 'fulfilled' || searchHandler?.state === 'rejected'
              : true
          }>
          <BusinessHierarchyList
            data={businessHierarchyData?.parentList}
            onViewEntities={onViewEntities}
            childList={businessHierarchyData?.childList}
            entityLevel={businessHierarchyData?.level}
          />
        </ModBox>
        {/* <SelectParentEntityList
          hide={false}
          title={'Parent Entity List'}
          data={data?.parent ?? []}
          columnFlexMapper={columnSize}
          headerTitles={headerTitle}
        />
        <Spacer size={40} direction={'vertical'} />
        <SelectParentEntityList
          hide={false}
          showAddButton={true}
          onAddPress={onAddChild}
          title={'Child Entity List'}
          data={data?.child ?? []}
          columnFlexMapper={columnSize}
          headerTitles={headerTitle}
        /> */}
      </ModBox>
    </Box>
  )
}

export { EntityHierarchy }
